import { useState, useEffect, useRef } from 'react';

export default function SearchPanel({
  input,
  loadThread,
  runSearch,
  searchLoading,
  searchQuery,
  searchResults,
  setSearchQuery,
  setSearchResults,
  setShowSearch,
  showSearch,
  threadHistory,
  userRecord,
  session,
  isMobile,
}) {
  return (
    <>
      {showSearch && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 200, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px' }} onClick={() => { setShowSearch(false); setSearchQuery(''); setSearchResults([]); }}>
          <div style={{ width: '580px', maxWidth: '92vw', background: '#1c1c1c', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 24px 64px rgba(0,0,0,0.8)', fontFamily: 'Georgia, serif' }} onClick={e => e.stopPropagation()}>

            {/* Input row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '14px 18px', borderBottom: '1px solid #252525' }}>
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, opacity: 0.4 }}>
                <circle cx="6.5" cy="6.5" r="5" stroke="#d4d4d4" strokeWidth="1.3"/>
                <path d="M10.5 10.5L14 14" stroke="#d4d4d4" strokeWidth="1.3" strokeLinecap="round"/>
              </svg>
              <input autoFocus value={searchQuery}
                onChange={e => { setSearchQuery(e.target.value); runSearch(e.target.value); }}
                placeholder="Search chats and projects"
                style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', color: '#d4d4d4', fontSize: '15px', fontFamily: 'Georgia, serif' }}
                onKeyDown={e => { if (e.key === 'Escape') { setShowSearch(false); setSearchQuery(''); setSearchResults([]); } }}
              />
              {searchLoading && <span style={{ color: '#555', fontSize: '12px' }}>···</span>}
              <button onClick={() => { setShowSearch(false); setSearchQuery(''); setSearchResults([]); }}
                style={{ background: '#2a2a2a', border: 'none', borderRadius: '4px', color: '#666', fontSize: '11px', padding: '3px 8px', cursor: 'pointer', fontFamily: 'Georgia, serif', letterSpacing: '0.04em', flexShrink: 0 }}>
                esc
              </button>
            </div>

            {/* List */}
            <div style={{ maxHeight: '420px', overflowY: 'auto' }}>

              {/* Search results */}
              {searchQuery && searchResults.length === 0 && !searchLoading && (
                <div style={{ padding: '24px 18px', color: '#555', fontSize: '13px' }}>Nothing found for "{searchQuery}"</div>
              )}
              {searchQuery && searchResults.map((r, i) => (
                <button key={i} onClick={() => { loadThread(r.session_id); setShowSearch(false); setSearchQuery(''); setSearchResults([]); }}
                  style={{ width: '100%', background: 'none', border: 'none', borderBottom: '1px solid #202020', cursor: 'pointer', padding: '11px 18px', textAlign: 'left', fontFamily: 'Georgia, serif', display: 'flex', alignItems: 'center', gap: '12px' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#242424'}
                  onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, opacity: 0.3 }}>
                    <path d="M18 10c0 4.42-3.58 8-8 8a7.96 7.96 0 01-4.47-1.37L2 18l1.37-3.53A7.96 7.96 0 012 10C2 5.58 5.58 2 10 2s8 3.58 8 8z" stroke="#d4d4d4" strokeWidth="1.4" strokeLinejoin="round"/>
                  </svg>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ color: '#bbb', fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {r.content.length > 72 ? r.content.slice(0, 72) + '…' : r.content}
                    </div>
                    <div style={{ color: '#555', fontSize: '11px', marginTop: '2px', letterSpacing: '0.04em' }}>
                      {r.role === 'user' ? 'you' : userRecord?.ai_name || 'shift'}
                    </div>
                  </div>
                </button>
              ))}

              {/* Recents - no query */}
              {!searchQuery && (
                <>
                  <div style={{ padding: '10px 18px 6px', color: '#444', fontSize: '11px', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Recent</div>
                  {threadHistory.length === 0 && (
                    <div style={{ padding: '16px 18px', color: '#555', fontSize: '13px' }}>No conversations yet.</div>
                  )}
                  {threadHistory.slice(0, 20).map((t, i) => {
                    const date = t.updated_at || t.created_at;
                    const dateLabel = date ? (() => {
                      const d = new Date(date);
                      const now = new Date();
                      const diff = Math.floor((now - d) / (1000 * 60 * 60 * 24));
                      if (diff === 0) return 'Today';
                      if (diff === 1) return 'Yesterday';
                      if (diff < 7) return d.toLocaleDateString('en-US', { weekday: 'short' });
                      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                    })() : '';
                    return (
                      <button key={t.id || i} onClick={() => { loadThread(t.id); setShowSearch(false); }}
                        style={{ width: '100%', background: 'none', border: 'none', borderBottom: '1px solid #202020', cursor: 'pointer', padding: '10px 18px', textAlign: 'left', fontFamily: 'Georgia, serif', display: 'flex', alignItems: 'center', gap: '12px' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#242424'}
                        onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                        <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style={{ flexShrink: 0, opacity: 0.3 }}>
                          <path d="M18 10c0 4.42-3.58 8-8 8a7.96 7.96 0 01-4.47-1.37L2 18l1.37-3.53A7.96 7.96 0 012 10C2 5.58 5.58 2 10 2s8 3.58 8 8z" stroke="#d4d4d4" strokeWidth="1.4" strokeLinejoin="round"/>
                        </svg>
                        <span style={{ flex: 1, color: '#999', fontSize: '13px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {t.title || t.what_shifted || 'Untitled'}
                        </span>
                        <span style={{ color: '#444', fontSize: '11px', flexShrink: 0 }}>{dateLabel}</span>
                      </button>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
